<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core';
import { ResultsFiltersBottomSheetWrapper, ResultsFiltersDropdownWrapper } from '#components';

const prefix = 'components.results.filters';

const properties = defineProps<{ disabled?: boolean }>();

const stopsStore = useStopsFilterStore();
const hoursStore = useHoursFilterStore();
const airlinesStore = useAirlinesFilterStore();
const searchResultIndexStore = useSearchResultIndexStore();
const searchCriteriaStore = useSearchCriteriaStore();

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMd = breakpoints.greaterOrEqual('md');
</script>

<template>
  <div class="flex items-center gap-2 overflow-x-auto scrollbar-none lg:overflow-visible">
    <ResultsFiltersAllBottomSheet :disabled="properties.disabled" />
    <component
      :is="isMd ? ResultsFiltersDropdownWrapper : ResultsFiltersBottomSheetWrapper"
      class="lg:flex-1"
      :trigger-button-label="$t(`${prefix}.stops`)"
      :has-active-filters="stopsStore.hasActiveFilters"
      :disabled="properties.disabled"
      :results-count="searchResultIndexStore.availableSearchResults.length"
      v-on="isMd ? {} : { reset: () => stopsStore.$reset() }"
    >
      <ResultsFiltersStops />
    </component>
    <component
      :is="isMd ? ResultsFiltersDropdownWrapper : ResultsFiltersBottomSheetWrapper"
      class="lg:flex-1"
      :trigger-button-label="$t(`${prefix}.hours`)"
      :has-active-filters="hoursStore.hasActiveFilters"
      :disabled="properties.disabled"
      :results-count="searchResultIndexStore.availableSearchResults.length"
      v-on="isMd ? {} : { reset: () => hoursStore.$reset() }"
    >
      <ResultsFiltersHours />
    </component>
    <ResultsFiltersHorizontalSingleDestination
      v-if="!searchCriteriaStore.committedIsMultiDestination"
      :disabled="properties.disabled"
    />
    <component
      :is="isMd ? ResultsFiltersDropdownWrapper : ResultsFiltersBottomSheetWrapper"
      class="lg:flex-1"
      :trigger-button-label="$t(`${prefix}.airlines`)"
      :has-active-filters="airlinesStore.hasActiveFilters"
      :disabled="properties.disabled"
      :results-count="searchResultIndexStore.availableSearchResults.length"
      v-on="isMd ? {} : { reset: () => airlinesStore.$reset() }"
    >
      <ResultsFiltersAirlines />
    </component>
  </div>
</template>
